export const dataLabelPlugin = {
  id: 'dataLabelPlugin',
  afterDatasetsDraw(chart: any, _args: any, { orders, inventory }: { orders?: number[]; inventory?: number[] }) {
    const { ctx, data } = chart;

    const totalExposureIndex = data.datasets.findIndex(
      (ds: any) => ds.label === 'Total Exposure' && ds.stack === 'exposure-1',
    );
    const exposureData = data.datasets[totalExposureIndex]?.data;

    if (!exposureData) {
      return;
    }
    const meta = chart.getDatasetMeta(totalExposureIndex);

    ctx.save();
    ctx.font = '12px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#444';
    meta.data.forEach((bar: any, index: number) => {
      const value = !orders?.[index]
        ? inventory?.[index]
          ? Infinity
          : 0
        : Math.floor(((inventory?.[index] || 0) / orders[index]) * 100);
      //exposureData[index];
      const x = bar.x + 6;
      const y = bar.y - 6;

      ctx.fillText(
        value === Infinity
          ? value.toLocaleString()
          : `${value.toLocaleString(undefined, { maximumFractionDigits: 0 })}%`,
        x,
        y,
      );
    });

    ctx.restore();
  },
};
